module.exports = __webpack_public_path__ + "static/media/header-back-dark.cfa40855.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/header-back-dark.svg
// module id = 795
// module chunks = 0